import xliff2js from './xliff2js.js';
import xliff12ToJs from './xliff12ToJs.js';
import js2xliff from './js2xliff.js';
import jsToXliff12 from './jsToXliff12.js';
import targetOfjs from './targetOfjs.js';
import sourceOfjs from './sourceOfjs.js';
import createjs from './createjs.js';
import createxliff from './createxliff.js';
import createxliff12 from './createxliff12.js';
export { xliff2js, xliff12ToJs, js2xliff, jsToXliff12, targetOfjs, sourceOfjs, createjs, createxliff, createxliff12 };
export default {
  xliff2js: xliff2js,
  xliff12ToJs: xliff12ToJs,
  js2xliff: js2xliff,
  jsToXliff12: jsToXliff12,
  targetOfjs: targetOfjs,
  sourceOfjs: sourceOfjs,
  createjs: createjs,
  createxliff: createxliff,
  createxliff12: createxliff12
};